$(function() {
    $("#start_dateBox").dxDateBox({
        min: new Date(2000, 0, 1),
        max: new Date(2029, 11, 31),
        value: new Date()
    });

    $('#start_dateBox input').attr('name', 'start_date');

    $("#end_dateBox").dxDateBox({
        min: new Date(2000, 0, 1),
        max: new Date(2029, 11, 31),
        value: new Date()
    });

    $('#end_dateBox input').attr('name', 'end_date');

    $("#starting-company-time").dxDateBox({
        type: "time",
        showClearButton: true,
        interval: 15,
        value: new Date()
    });

    $('#starting-company-time input').attr('name', 'starting_company');

    $("#starting-work-time").dxDateBox({
        type: "time",
        showClearButton: true,
        interval: 15,
        value: new Date()
    });

    $('#starting-work-time input').attr('name', 'starting_work');

    $("#end-company-time").dxDateBox({
        type: "time",
        showClearButton: true,
        interval: 15,
        value: new Date()
    });

    $('#end-company-time input').attr('name', 'end_company');

    $("#end-work-time").dxDateBox({
        type: "time",
        showClearButton: true,
        interval: 15,
        value: new Date()
    });

    $('#end-work-time input').attr('name', 'end_work');




    if ($('#start-date-current').val() != null) {
        var start_date_current = $('#start-date-current').val().split('-');
        var value = new Date(start_date_current[2], start_date_current[1] -1, start_date_current[0]);

        $("#start-date-edit").dxDateBox({
            displayFormat: "d-M-y",
            type: "date",
            value: value
        });

        $('#start-date-edit input').attr('name', 'start_date');
    }else{
        $("#start-date-edit").dxDateBox({
            displayFormat: "d-M-y",
            min: new Date(2000, 0, 1),
            max: new Date(2029, 11, 31),
            value: new Date()
        });

        $('#start-date-edit input').attr('name', 'start_date');
    }

    if ($('#end-date-current').val() != null) {
        var end_date_current = $('#end-date-current').val().split('-');
        var value = new Date(end_date_current[2], end_date_current[1] -1, end_date_current[0]);

        $("#end-date-edit").dxDateBox({
            displayFormat: "d-M-y",
            type: "date",
            value: value
        });

        $('#end-date-edit input').attr('name', 'end_date');
    }
    else{
        $("#end-date-edit").dxDateBox({
            displayFormat: "d-M-y",
            min: new Date(2000, 0, 1),
            max: new Date(2029, 11, 31),
            value: new Date()
        });

        $('#end-date-edit input').attr('name', 'end_date');
    }

    if ($('#starting-work-current').val() != null) {
        $("#starting-work-time-edit").dxDateBox({
            displayFormat: "HH:mm",
            type: "time",
            showClearButton: true,
            interval: 15,
            value: new Date('1970-01-01 ' + $('#starting-work-current').val())
        });

        $('#starting-work-time-edit input').attr('name', 'starting_work');
    }else{
        $("#starting-work-time-edit").dxDateBox({
            displayFormat: "HH:mm",
            type: "time",
            showClearButton: true,
            interval: 15,
            value: new Date()
        });

        $('#starting-work-time-edit input').attr('name', 'starting_work');
    }

    if ($('#end-work-current').val() != null) {

        $("#end-work-time-edit").dxDateBox({
            displayFormat: "HH:mm",
            type: "time",
            showClearButton: true,
            interval: 15,
            value: new Date('1970-01-01 ' + $('#end-work-current').val())
        });

        $('#end-work-time-edit input').attr('name', 'end_work');
    }else{
        $("#end-work-time-edit").dxDateBox({
            displayFormat: "HH:mm",
            type: "time",
            showClearButton: true,
            interval: 15,
            value: new Date()
        });

        $('#end-work-time-edit input').attr('name', 'end_work');
    }
    if ($('#arrival-mcn-time-current').val() != null) {

        $("#arrival-mcn-time-time-edit").dxDateBox({
            displayFormat: "HH:mm",
            type: "time",
            showClearButton: true,
            interval: 15,
            value: new Date('1970-01-01 ' + $('#arrival-mcn-time-current').val())
        });

        $('#arrival-mcn-time-time-edit input').attr('name', 'arrival_mcn_time');
    }else{
        $("#arrival-mcn-time-time-edit").dxDateBox({
            displayFormat: "HH:mm",
            type: "time",
            showClearButton: true,
            interval: 15,
            value: new Date()
        });

        $('#arrival-mcn-time-time-edit input').attr('name', 'arrival_mcn_time');
    }
    if ($('#leave_mcn_time-current').val() != null) {

        $("#leave-mcn-time-time-edit").dxDateBox({
            displayFormat: "HH:mm",
            type: "time",
            showClearButton: true,
            interval: 15,
            value: new Date('1970-01-01 ' + $('#leave_mcn_time-current').val())
        });

        $('#leave-mcn-time-time-edit input').attr('name', 'leave_mcn_time');
    }else{
        $("#leave-mcn-time-time-edit").dxDateBox({
            displayFormat: "HH:mm",
            type: "time",
            showClearButton: true,
            interval: 15,
            value: new Date()
        });

        $('#leave-mcn-time-time-edit input').attr('name', 'leave_mcn_time');
    }
});

function getDateOfISOWeek(w, y) {
    var simple = new Date(y, 0, 1 + (w - 1) * 7);
    var dow = simple.getDay();
    var ISOweekStart = simple;
    if (dow <= 4)
        ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    else
        ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    return ISOweekStart;
}




// WEBPACK FOOTER //
// ./resources/js/components/dates.js